export default function ChipSelect({
  options = [],
  value,
  onChange,
  error,
}) {
  const errCls = error ? ' has-error' : ''
  return (
    <div
      className={`chip-group${errCls}`}
      role="radiogroup"
    >
      {options.map((o) => {
        const isSelected = value === o.value
        return (
          <button
            key={o.value}
            type="button"
            role="radio"
            className="chip"
            aria-checked={isSelected}
            aria-pressed={isSelected}
            onClick={() => onChange(isSelected ? '' : o.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') e.preventDefault()
            }}
          >
            {o.label}
          </button>
        )
      })}
    </div>
  )
}
